import {api, apiProvider} from '@/core/api/'

const providerEndpoint = 'api/provider'
export default {
  getProvidertCompanies(properties) {
    return api.get(`${providerEndpoint}/companies`, {
      params: {
        ...properties,
      },
    })
  },
  getProviderCompanies(properties) {
    return apiProvider.get(
      `api/providerregistryvisit/companies/${properties.academicYearId}/${properties.month}`
    )
  },
  getAllProvidertCompaniesByYear(properties) {
    return api.get('api/provider/allcompanies', {
      params: {
        ...properties,
      },
    })
  },
  getProvidersAvailable(academicYearId, period, municipalityId) {
    return api.get(
      `api/appointment/providersAvailable?academicYearId=${academicYearId}&period=${period}&municipalityId=${municipalityId}`
    )
  },
  getProvidersAvailableWithVisits(academicYearId, semester, month) {
    return api.get(`api/provider/providersavailablewithvisits?academicYearId=${academicYearId}`
      + (semester ? `&semester=${semester}` : '')
      + (month ? `&month=${month}` : '')
    );
  },
  getBillingCompanyByYear(properties) {
    return api.get('api/provider/billingcompanies', {
      params: {
        ...properties,
      },
    })
  },
  getCompaniesByEffectiveContract(academicYearId) {
    return api.get(
      `api/provider/companiesbyeffectivecontract/${academicYearId.academicYearId}`
    )
  },
  getProviderByYearAndCenter(academicYearId, centerId) {
    return api.get(
      `api/provider/providerbyyearandcenter/${academicYearId}/${centerId}`
    )
  },
  getEligibleStudentProviders(academicYearId) {
    return api.get(`${providerEndpoint}/eligiblestudentproviders`, {
      params: {
        ...academicYearId
      }
    })
  },

  getProviderCenters(payload) {
    return apiProvider.get(`api/providerregistryvisit/centers/${payload.academicYearId}/${payload.month}`, {
      params: {
        specialistId: payload.specialistId,
        companyId: payload.companyId,
        onlyUseBillingCenter: payload.onlyUseBillingCenter,
      },
    })
  }
}
